<template>
  <div id="app" class="antialiased">
    <router-view />
    <v-dialog />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style src="@/styles/main.css"></style>
